import request from ".";

export const vacanciesApi = {
  getVacancies: () => request.post(`Vacancies/getAllVacancies`),
};
